export var DEFAULT = Symbol('Default');
export function match(matchOn, cases) {
  var val = matchOn in cases ? cases[matchOn] : DEFAULT in cases ? cases[DEFAULT] : noMatch(matchOn);
  return typeof val === 'function' ? val() : val;
}
function noMatch(matchOn) {
  throw new Error('No match for ' + matchOn);
}
match.DEFAULT = DEFAULT;
//# sourceMappingURL=patternMatchUtil.js.map
